import React from 'react';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import Autocomplete from "../../../components/AutoComplete";
import SelectInput from "../../../components/SelectInput";
import { Checkbox } from '../../../components/ui/checkbox';

const FormFieldInput = ({ 
  field,
  fieldType, // 'text', 'email', 'password', 'checkbox', 'select'
  label,
  isLoading,
  value,
  options,
  handleInputChange,
  className,
  required,
  error,
  checkboxLabel,
  disabled=false
}) => {

    // Render the label
    const renderLabel = () => (
        <Label htmlFor={field} className="w-full sm:w-1/6 font-medium whitespace-nowrap">
        {label || (field.charAt(0).toUpperCase() + field.slice(1))}
        {required && <span className="text-black-500 ml-1">*</span>}
        </Label>
    );

    // Render the appropriate input based on fieldType
    const renderInput = () => {
        switch (fieldType) {
        case 'email':
            return isLoading ? (
            <span>Loading...</span>
            ) : (
                <>
                    <Autocomplete
                        options={options || []}
                        placeholder={`Enter ${field}`}
                        value={value || ""}
                        onChange={(email) => handleInputChange(field, email || "")}
                        onSelect={(selectedEmail) => handleInputChange(field, selectedEmail)}
                        error={error}
                    />
                    {/* <SelectInput
                        key="email"
                        fieldKey="email"
                        type="list"
                        list={options}
                        onChange={(email) => handleInputChange(field, email || "")}
                        selectedValue={value}
                        placeholder={`Enter ${field}`}
                        error={error}
                    /> */}
                    {error && <small className='text-red-500'>{error}</small>}
                </>
            );
        
        case 'checkbox':
            return (
                <div className="flex items-center space-x-2">
                    <Checkbox
                        id={field}
                        checked={value || false}
                        onCheckedChange={(checked) => handleInputChange(field, checked)}
                    />
                    {checkboxLabel && (
                        <Label
                        htmlFor={field}
                        className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                        >
                        {checkboxLabel}
                        </Label>
                    )}
                </div>
            );
        
        case 'select':
            return (
            <>
                <SelectInput
                    list={options}
                    placeholder={`Select ${field}`}
                    onChange={value => handleInputChange(field, value)}
                    selectedValue={value}
                    error={error}
                    disabled={disabled}
                />
                {error && <small className="text-red-500">{error}</small>}
            </>
            );
        
        default:
            return (
                <>
                    <Input
                        id={field}
                        type={fieldType || "text"}
                        placeholder={`Enter ${field}`}
                        value={value || ""}
                        autoComplete={`new-${field}`}
                        onChange={(e) => handleInputChange(field, e.target.value)}
                        className={`${className || ""} flex-1 bg-white dark:bg-secondary focus-visible:ring-primary-foreground`}
                        disabled={disabled}
                    />
                    {error && <small className="text-red-500">{error}</small>}
                </>
            );
        }
    };

    return (
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-2 sm:gap-4 w-full mb-4 sm:mb-0">
            {renderLabel()}
            <div className="w-5/6">
                {renderInput()}
            </div>
        </div>
    );
};

export default FormFieldInput;